module.exports = __webpack_public_path__ + "media/configurations/SX-X-P-686cb1ce.png";